import './Layout.css';
import logo from '../Images/logo.png'
import logo22 from '../Images/logo2.png'
import noronInfo from '../Images/noronInfo.png'
import * as React from 'react';
import { Outlet } from 'react-router-dom';


export default function Layout1({ logo2 = false }) {

    return (
        <>
        {/*
            <div className="fixed-top">
                <div className='d-flex justify-content-center pt-5'>
                    <img src={noronInfo} />
                </div>
            </div>
            */
        }
            <div className="container  vh-100 d-flex align-items-center justify-content-center">

                <div className='w-100'>
                    <div className="row align-items-center  ">
                        <div className="col-md-10 mx-auto col-lg-5 " id="colMain2">

                            <div className="form-floating mb-3 d-flex justify-content-center" >
                                {logo2 ? (<img src={logo22} />) : (<img src={logo} />)}
                            </div>
                            <Outlet />

                        </div>
                    </div>
                </div>
            </div>
            <div className="sticky-bottom">
                <div className='d-flex justify-content-center pb-3 text-white fs1'>
                    تحت معاونت علوم، تحقیقات و فناوری ناجا و پلیس پیشگیری
                </div>
            </div>


        </>
    );

}